import { connect } from 'react-redux'
import { flow, flatten, uniqBy, map, compact } from 'lodash/fp'
import BlogIndex from './BlogIndex'
import { filterAndOrderBlogs } from '../Blog.utils'
import { getEntries } from 'features/Cms/Cms.actions'
import showBlogFilterModal from 'features/Blog/BlogFilterModal'

const stateToProps = ({ cms }) => {
  const articles = cms.blogPost || []
  return {
    articles: filterAndOrderBlogs(articles),
    categories: flow(map('fields.categories'), flatten, uniqBy('fields.name'), compact)(articles),
    authors: flow(map('fields.author'), uniqBy('fields.name'))(articles),
  }
}

const dispatchToProps = {
  getArticles: () => getEntries({ contentType: 'blogPost' }),
  showBlogFilterModal,
}

export default connect(stateToProps, dispatchToProps)(BlogIndex)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Blog/BlogIndex/BlogIndex.container.js